import { createUseQuery } from 'api/common/createUseQuery'
import { fetchMe } from 'api/fetchers/me/fetchMe'
import { ApiQueryKeys } from 'constants/apiQueryKeys'

export const useMe = createUseQuery({
  queryKey: ApiQueryKeys.ME,
  fetcher: fetchMe,
  selector: res => res?.data,
})
